import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { ServiceClass } from "../../../../http/screwConnector/types/normativeTables";
import { useScrewConnectorServiceClassesApi } from "../../../../http/screwConnector/useAdminNormativeTables";
import ServiceClassForm from "./ServiceClassForm";

const AdminServiceClasses: FC = () => {
  const i18n = useI18n();
  const t = i18n.translation.screwConnectorModule.normativeTables.serviceClasses;
  const api = useScrewConnectorServiceClassesApi();

  return (
    <AdminCrudTable<ServiceClass>
      filterPrefix="service_classes"
      useList={api.useServiceClasses}
      head={
        <>
          <TableHeadCell align="left">{t.fields.code}</TableHeadCell>
          <TableHeadCell align="left">{t.fields.name}</TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.code}</TableCell>
          <TableCell>{item.name}</TableCell>
        </>
      )}
      onDelete={(item) => api.deleteServiceClass(item.code)}
      deleteTitle={t.singular}
      canAdd
      renderForm={(item, onClose) => <ServiceClassForm serviceClass={item} onClose={onClose} />}
    />
  );
};

export default AdminServiceClasses;
